import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import VisibilityIcon from "../assets/SVGs/Login/VisibilityIcon";
import { Box, IconButton, Stack, useMediaQuery } from "@mui/material";
import { ClosedBusinessesAPI } from "../api/closed-business";
import { filterArrayByString, formatCurrency } from "../componets/helper";
import AppLayout from "../componets/AppLayout/AppLayout";
import GridCustomHeader from "../componets/AppLayout/GridCustomHeader";
import { DataGrid } from "@mui/x-data-grid";
import AddClosedBusinessModal from "../componets/Modal/AddClosedBusinessModal";
import { defaultEditFormState } from "../componets/constant";
import EditClosedBusinessModal from "../componets/Modal/EditClosedBusinessModal";
import dayjs from "dayjs";
import { useAppContext } from "../context/AppContext";
import { DatePicker } from "@mui/x-date-pickers";
import ReportModal from "../componets/Modal/ReportModal";
import TextSlider from "../componets/TextSlider";
import RecurringClosedBusinessGrid from "../componets/ClosedBusinessTabs/RecurringClosedBusinessGrid";
import MemberNameCell from "../componets/MemberNameCell";

const ClosedBusiness = () => {
  const { openSnack } = useAppContext();
  const navigate = useNavigate();
  const isMobileTable = useMediaQuery("(max-width:850px)");
  const [openModal, setOpenModal] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [searchText, setSearchText] = useState("");
  const [data, setData] = useState([]);
  // const [referrals, setReferrals] = useState([]);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const [openReportModal, setOpenReportModal] = useState(false);
  const [activeTab, setActiveTab] = useState(0);

  const [openEditModal, setOpenEditModal] = useState(defaultEditFormState);

  const handleTabChange = (_event, newValue) => {
    setActiveTab(newValue);
    setIsLoading(true);
  };

  const isRecurringTab = activeTab === 1;

  const handleSearch = (searchString) => {
    setSearchText(searchString);
  };

  // const fetchReferrals = async () => {
  //   try {
  //     const response = await ReferralsAPI.getReferrals();
  //     setReferrals(response?.items || []);
  //     return;
  //   } catch (e) {
  //     const status = e.response?.status;
  //     if (status === 401) {
  //       navigate("/login");
  //     }
  //     console.error("Error during fetching report", e);
  //   }
  // };

  const columns = [
    {
      field: "closed_business_name",
      headerName: "Closed Business Name",
      flex: 1,
      minWidth: isMobileTable ? 220 : undefined,
      renderCell: (param) => param?.row?.referral?.referral_name,
      // editable: true,
    },
    {
      field: "closed_business_sender",
      headerName: "Closed Business Sender",
      flex: 1,
      minWidth: isMobileTable ? 240 : undefined,
      valueGetter: (params) => `${params?.first_name} ${params?.last_name}`,
      renderCell: (param) => (
        <MemberNameCell member={param?.row?.closed_business_sender} />
      ),
    },
    {
      field: "closed_business_receiver",
      headerName: "Closed Business Receiver",
      flex: 1,
      minWidth: isMobileTable ? 240 : undefined,
      valueGetter: (params) => `${params?.first_name} ${params?.last_name}`,
      renderCell: (param) => (
        <MemberNameCell member={param?.row?.closed_business_receiver} />
      ),
    },
    {
      field: "closed_business_date",
      headerName: "Closed Business Date",
      flex: 1,
      minWidth: isMobileTable ? 220 : undefined,
      editable: true,
      type: "date",
      valueGetter: (params) => {
        return dayjs(params).toDate(); // returns a native JS Date
      },
      renderCell: (params) => {
        return params.value ? dayjs(params.value).format("MM/DD/YYYY") : "";
      },
      renderEditCell: (params) => {
        const handleChange = (event) => {
          const newValue = event;
          params.api.setEditCellValue({
            id: params.id,
            field: "closed_business_date",
            value: newValue,
          });
        };

        return (
          <DatePicker
            value={dayjs(params.value)}
            onChange={handleChange}
            format="MM/DD/YYYY"
            slotProps={{
              textField: {
                margin: "normal",
                fullWidth: true,
                id: "closed_business_date",
                name: "closed_business_date",
                className: "login-textField",
                size: "small",
              },
            }}
          />
        );
      },
    },
    {
      field: "dollar_amount_of_realized_revenue",
      headerName: "Realized Revenue",
      flex: 1,
      editable: true,
      minWidth: isMobileTable ? 200 : undefined,
      renderCell: (params) => {
        return formatCurrency(params.value);
      },
    },
    {
      field: "recurrent",
      headerName: "Recurrent",
      flex: 1,
      minWidth: isMobileTable ? 150 : undefined,
      renderCell: (params) => {
        return params.value !== null && params.value !== undefined
          ? params.value
            ? "Yes"
            : "No"
          : "N/A";
      },
    },
    {
      field: "actions",
      headerName: "Actions",
      width: 100,
      filterable: false,
      sortable: false,
      renderCell: (params) => (
        <IconButton
          aria-label="view"
          size="small"
          onClick={() =>
            setOpenEditModal({
              open: true,
              id: params?.row?.id,
              title: params?.row?.closed_business_name,
              invitationType: params?.row?.invitation_type,
            })
          }
        >
          <VisibilityIcon
            sx={{
              color: "#64748B",
            }}
          />
        </IconButton>
      ),
    },
  ];

  const fetch = async () => {
    setIsLoading(true);
    try {
      setData(await ClosedBusinessesAPI.getClosedBusinesses());
    } catch (e) {
      console.log(e.response);
      const status = e.response?.status;
      if (status === 401) {
        navigate("/login");
      }
      console.error("Error during fetching report", e);
    } finally {
      setIsLoading(false);
    }
  };

  // useEffect(() => {
  //   fetchReferrals();
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, []);

  useEffect(() => {
    if (isLoading && !isRecurringTab) fetch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoading, isRecurringTab]);

  const getRowsData = () => {
    const dummyRows = [...(data?.items || [])];

    return filterArrayByString(dummyRows || [], searchText);
  };

  const processRowUpdate = async (newRow, oldRow) => {
    try {
      await EditClosedBusiness(newRow);
      return newRow; // Return the updated row
    } catch (error) {
      console.error("Row update failed:", error);
      return oldRow; // Revert to the old row if the update fails
    }
  };

  const EditClosedBusiness = async (form) => {
    const formObj = {
      dollar_amount_of_realized_revenue: form.dollar_amount_of_realized_revenue,
      referral_id: form.referral_name?.id,
      closed_business_date: dayjs(form.closed_business_date).format(
        "YYYY-MM-DD",
      ),
    };
    try {
      await ClosedBusinessesAPI.updateClosedBusiness(formObj, form?.id);
      openSnack("Closed Business information updated successfully.", "success");
      setIsLoading(true);
    } catch (error) {
      console.error("Error adding Closed Business:", error);
    }
  };

  return (
    <AppLayout>
      <Box
        sx={{
          width: "100%",
          padding: isMobileTable ? "8px" : "24px",
        }}
      >
        <GridCustomHeader
          isLoading={isLoading}
          setIsLoading={setIsLoading}
          searchText={searchText}
          handleSearch={handleSearch}
          setOpenModal={setOpenModal}
          buttonText="Add New Closed Business"
          headerName="Closed Business"
          moreOptions
          handleClick={handleClick}
          handleClose={handleClose}
          open={open}
          showClosedBusiness
          anchorEl={anchorEl}
          setOpenReportModal={setOpenReportModal}
          hideAddButton={isRecurringTab}
        />
        <Box sx={{ marginBottom: "16px" }}>
          <TextSlider
            activeTab={activeTab}
            handleTabChange={handleTabChange}
            tab1="Closed Businesses"
            tab2="Recurring Closed Business"
          />
        </Box>
        {isRecurringTab ? (
          <RecurringClosedBusinessGrid
            isLoading={isLoading}
            setIsLoading={setIsLoading}
            searchText={searchText}
          />
        ) : (
          <Stack
            sx={{
              width: "100%",
              "& .MuiDataGrid-root": {
                borderRadius: "8px",
              },
            }}
            className="customDataGridFigma"
          >
            <DataGrid
              rows={getRowsData() || []}
              columns={columns}
              loading={isLoading}
              initialState={{
                pagination: { paginationModel: { pageSize: 20 } },
              }}
              processRowUpdate={processRowUpdate}
              pageSizeOptions={[10, 15, 20, 25]}
              checkboxSelection={false}
              rowSelection={false}
              rowHeight={48}
              columnHeaderHeight={40}
              getRowClassName={(params) => {
                const customClassName =
                  params.indexRelativeToCurrentPage % 2 !== 0 ? "bg-gray" : "";
                return ` ${customClassName}`.trim();
              }}
              slotProps={{
                loadingOverlay: {
                  variant: "linear-progress",
                  noRowsVariant: "linear-progress",
                },
              }}
              localeText={{
                noRowsLabel: "No Closed Businesses found.",
              }}
              disableVirtualization
            />
          </Stack>
        )}
      </Box>
      {openModal && (
        <AddClosedBusinessModal
          open={openModal}
          handleClose={() => setOpenModal(false)}
          setIsLoading={setIsLoading}
        />
      )}

      {openEditModal.open && (
        <EditClosedBusinessModal
          open={openEditModal?.open}
          id={openEditModal?.id}
          handleClose={() => setOpenEditModal(defaultEditFormState)}
          setIsLoading={setIsLoading}
          title={openEditModal?.title}
          invitationType={openEditModal?.invitationType}
        />
      )}
      {openReportModal?.open && (
        <ReportModal
          open={openReportModal?.open}
          handleClose={() => setOpenReportModal({})}
          showAllTime={openReportModal?.showAllTime}
          generalClosedBusiness
        />
      )}
    </AppLayout>
  );
};

export default ClosedBusiness;
